/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  initState,
  sendForm,
  setFieldSum
} from 'mt-react-common/modules/authUserOutputCash/combines/authUserOutputCashFrom/actions';
import {
  selectFieldOutputAccountsType,
  selectOutputSumFromCommission,
  selectFieldSum,
  selectResultObject
} from 'mt-react-common/modules/authUserOutputCash/combines/authUserOutputCashFrom/selectors';
import {
  hasFieldError,
  selectFirstErrorByFiled,
  clearErrorByField
} from 'mt-react-common/common/reducers/_formErrors/reducer';
import { sendGetAuthAccountDataRequest } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';
import { selectItemById } from 'mt-react-common/common/reducers/_list/reducer';

import {
  sendRequest,
  changeQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import UserOutputCashAccounts from './UserOutputCashAccountsNavigate/UserOutputCashAccountsNavigate';
import { moneyFormat } from '../../../mt-react-common/utils/formatter';

const listReduceName =
  'authUserOutputCashModule.lists.authUserOutputCashHistoryList';

class UserOutputCashForm extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.requestStatusData.codeResponse !==
        this.props.requestStatusData.codeResponse &&
      this.props.requestStatusData.codeResponse === 200
    ) {
      this.props.updateAccountInfo();
      this.props.initState();
      this.props.reloadUserOutputCashHistoryTable();
    }
  }

  getRate = () => {
    const outputAccountsTypeId = this.props.fieldOutputAccountsType.value;
    const outputAccountItem = this.props.selectItemById(outputAccountsTypeId);
    if (outputAccountItem && outputAccountItem.rate) {
      return `1 ${outputAccountItem.rate.target_currency} = ${outputAccountItem.rate.rate} ${outputAccountItem.rate.base_currency}`;
    }
    return null;
  };

  getOutputDetails = () => {
    const sourceSumRaw = this.props.fieldSum.value; // 1) что введёт пользователь
    const sourceSum = Number(sourceSumRaw) || 0;
    const sourceCurrency = 'RUB';

    const outputAccountItem = this.props.selectItemById(
      this.props.fieldOutputAccountsType.value
    );

    const hasRate =
      outputAccountItem &&
      outputAccountItem.rate &&
      typeof outputAccountItem.rate.rate === 'number' &&
      outputAccountItem.rate.target_currency;

    const targetCurrency = hasRate
      ? outputAccountItem.rate.target_currency
      : sourceCurrency;

    const targetRate = hasRate ? outputAccountItem.rate.rate : 1;

    // 2) конвертация полной суммы списания в валюту вывода
    // считаем, что rate = сколько RUB за 1 targetCurrency
    // => targetSum = RUB / rate
    const convertedTargetSum = hasRate ? sourceSum / targetRate : sourceSum;

    // 3) считаем комиссию сервиса исходя из СУММЫ В ВАЛЮТЕ ВЫВОДА
    const commissionPercent = outputAccountItem
      ? Number(outputAccountItem.totalCommission) || 0
      : 0; // %

    const commissionFixedCharge = outputAccountItem
      ? Number(outputAccountItem.fixedCharge) || 0
      : 0; // фикс в targetCurrency

    // процентная комиссия в targetCurrency
    const commissionPercentAmount =
      commissionPercent > 0
        ? (convertedTargetSum * commissionPercent) / 100
        : 0;

    // общая комиссия сервиса в targetCurrency
    const totalCommissionTarget =
      commissionPercentAmount + commissionFixedCharge;

    // сколько реально ПОСТУПИТ на счёт в валюте вывода
    const receivedTargetSum = Math.max(
      convertedTargetSum - totalCommissionTarget,
      0
    );

    return {
      // что ввёл пользователь (и что спишется)
      sourceSum, // Спишется
      sourceCurrency, // 'RUB'

      // сумма после конвертации ДО комиссий
      convertedTargetSum, // сумма в targetCurrency до комиссий

      // комиссии сервиса (в валюте вывода)
      commissionPercent, // %
      commissionPercentAmount, // сумма % комиссии в targetCurrency
      commissionFixedCharge, // фиксированная комиссия в targetCurrency
      totalCommission: totalCommissionTarget,

      // что ПОСТУПИТ на счёт
      outputSum: receivedTargetSum,
      outputSumCurrency: targetCurrency,

      // данные курса
      targetCurrency,
      targetRate
    };
  };

  handleChangeField = async event => {
    switch (event.target.name) {
      case 'sum': {
        if (this.props.hasFieldError(event.target.name)) {
          this.props.clearErrorByField(event.target.name);
        }
        this.props.setFieldSum(event.target.value);
        break;
      }
      default:
        break;
    }
  };

  render() {
    const rate = this.getRate();
    const outputDetails = this.getOutputDetails();
    const errorDesc = fieldName => {
      if (this.props.hasFieldError(fieldName)) {
        return (
          <React.Fragment>
            <small className="help-block">
              {this.props.selectFirstErrorByFiled(fieldName).message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <React.Fragment>
        <div className="panel panel-default panel-heading_padding-large panel-body_bg-sub panel-footer_padding-large">
          <div className="panel-heading">
            <h1 className="panel-title text-center">
              <i className="fa fa-rub" aria-hidden="true" />{' '}
              {t('Вывод <strong>средств</strong>')}
            </h1>
          </div>
          <form>
            <div className="panel-body">
              <div
                className={`form-group ${
                  this.props.hasFieldError('sum') ? 'has-error' : ''
                }`}
              >
                <label className="control-label" htmlFor="inputSum">
                  {t('Сумма вывода')}
                </label>
                <input
                  onChange={this.handleChangeField}
                  value={this.props.fieldSum.value}
                  type="number"
                  className="form-control"
                  placeholder={t('Введите сумму вывода')}
                  name="sum"
                  id="inputSum"
                />
                {errorDesc('sum')}
                <div className="p-2 text-muted">{rate}</div>
              </div>
              <div
                className={`form-group ${
                  this.props.hasFieldError('output_accounts_type')
                    ? 'has-error'
                    : ''
                }`}
              >
                <UserOutputCashAccounts
                  reducerNameOutputCashFrom={
                    this.props.reducerNameOutputCashFrom
                  }
                  reducerNameOutputCashAccounts={
                    this.props.reducerNameOutputCashAccounts
                  }
                />
                {errorDesc('payout_accounts_type')}
              </div>
            </div>
            <div className="panel-footer">
              {false && <pre>{JSON.stringify(outputDetails, null, 2)}</pre>}
              <div className="row">
                <div className="col-xs-8 text-center">
                  <p className="form-control-static">
                    {moneyFormat(
                      outputDetails.outputSum,
                      outputDetails.outputSumCurrency
                    )}
                  </p>
                </div>
                <div className="col-xs-16">
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    onClick={() => this.props.sendForm()}
                  >
                    {t('Вывести')}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }
}

UserOutputCashForm.propTypes = {
  reducerNameOutputCashFrom: PropTypes.string.isRequired,
  reducerNameOutputCashAccounts: PropTypes.string.isRequired,

  setFieldSum: PropTypes.func.isRequired,

  sendForm: PropTypes.func.isRequired,
  initState: PropTypes.func.isRequired,

  requestStatusData: PropTypes.shape({
    requestInProcess: PropTypes.bool,
    codeResponse: PropTypes.number
  }).isRequired,

  hasFieldError: PropTypes.func.isRequired,
  selectFirstErrorByFiled: PropTypes.func.isRequired,
  clearErrorByField: PropTypes.func.isRequired,

  fieldSum: PropTypes.shape({
    value: PropTypes.any.isRequired
  }).isRequired,

  // eslint-disable-next-line react/no-unused-prop-types
  resultObject: PropTypes.shape({
    externalPaymentUrl: PropTypes.string
  }).isRequired,
  // outputSumFromCommission: PropTypes.number.isRequired,
  fieldOutputAccountsType: PropTypes.number.isRequired,
  updateAccountInfo: PropTypes.func.isRequired,

  reloadUserOutputCashHistoryTable: PropTypes.func.isRequired,
  selectItemById: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestStatusData: selectRequestStatusData(
    props.reducerNameOutputCashFrom,
    state
  ),
  hasFieldError: fieldName =>
    hasFieldError(state, props.reducerNameOutputCashFrom, fieldName),
  selectFirstErrorByFiled: fieldName =>
    selectFirstErrorByFiled(state, props.reducerNameOutputCashFrom, fieldName),

  fieldSum: selectFieldSum(state, props.reducerNameOutputCashFrom),

  outputSumFromCommission: selectOutputSumFromCommission(
    state,
    props.reducerNameOutputCashFrom
  ),

  fieldOutputAccountsType: selectFieldOutputAccountsType(
    state,
    props.reducerNameOutputCashFrom
  ),

  resultObject: selectResultObject(state, props.reducerNameOutputCashFrom),
  selectItemById: id =>
    selectItemById(state, props.reducerNameOutputCashAccounts, id)
});

const mapDispatchToProps = (dispatch, props) => ({
  clearErrorByField: value =>
    dispatch(clearErrorByField(props.reducerNameOutputCashFrom, value)),
  setFieldSum: value =>
    dispatch(setFieldSum(props.reducerNameOutputCashFrom, value)),
  sendForm: () => dispatch(sendForm(props.reducerNameOutputCashFrom)),
  initState: () => dispatch(initState(props.reducerNameOutputCashFrom)),
  updateAccountInfo: () => dispatch(sendGetAuthAccountDataRequest()),

  // Обновление таблицы с выплатами
  reloadUserOutputCashHistoryTable: () => {
    dispatch(changeQueryParams(listReduceName, {}));
    dispatch(sendRequest(listReduceName));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserOutputCashForm);



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashForm/UserOutputCashForm.js